import { useCreation, useSize } from 'ahooks';
import classnames from 'classnames';
import React, { createContext, useContext, useEffect, useReducer, useRef } from 'react';
import { calc, generateUuid } from '../_util/utils';
import Elevation from '../elevation';
import { Row, RowItem } from './row';
import './style/index';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Context = /*#__PURE__*/createContext({});
const reducer = (a, b) => ({
  ...a,
  ...b
});
const Container = props => {
  const {
    header,
    footer,
    children,
    alwaysHideDescription = false,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-container");
  const ref = useRef(null);
  const size = useSize(ref);
  const [descVisibleMap, updateDescVsiible] = useReducer(reducer, {});
  const sidebarWidth = useCreation(() => {
    return size !== null && size !== void 0 && size.width ? calc.mul(size.width, 0.32) : 0;
  }, [size === null || size === void 0 ? void 0 : size.width]);
  const showRightDesc = useCreation(() => {
    return Object.keys(descVisibleMap).some(k => descVisibleMap[k]);
  }, [descVisibleMap]);
  return /*#__PURE__*/_jsx(Elevation, {
    ref: ref,
    type: 3,
    className: classnames(baseClassName, className, {
      alwaysHideDescription
    }),
    style: style,
    ...restProps,
    children: /*#__PURE__*/_jsxs(Context.Provider, {
      value: {
        sidebarWidth,
        descVisibleMap,
        updateDescVsiible
      },
      children: [!!header && /*#__PURE__*/_jsx(Elevation, {
        type: 3,
        className: "".concat(baseClassName, "-header"),
        children: header
      }), /*#__PURE__*/_jsxs("div", {
        className: "".concat(baseClassName, "-body"),
        children: [/*#__PURE__*/_jsx("div", {
          className: "".concat(baseClassName, "-body--left"),
          children: children
        }), showRightDesc && /*#__PURE__*/_jsx(Elevation, {
          type: 5,
          className: "".concat(baseClassName, "-body--right"),
          style: {
            width: sidebarWidth,
            borderTopLeftRadius: 0,
            borderTopRightRadius: header ? 0 : undefined,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: footer ? 0 : undefined
          }
        })]
      }), !!footer && /*#__PURE__*/_jsx(Elevation, {
        type: 3,
        className: "".concat(baseClassName, "-footer"),
        children: footer
      })]
    })
  });
};
export const useDescriptionConfig = description => {
  const key = useCreation(generateUuid, []);
  const {
    sidebarWidth,
    updateDescVsiible
  } = useContext(Context);
  const toggleDesc = visible => {
    updateDescVsiible === null || updateDescVsiible === void 0 || updateDescVsiible({
      [key]: visible
    });
  };
  useEffect(() => {
    toggleDesc(!!description);
    return () => {
      toggleDesc(false);
    };
  }, [!!description]);
  return {
    sidebarWidth
  };
};
Container.Row = Row;
Container.RowItem = RowItem;
export default Container;